import { createBlocksModel } from '@wix/yoshi-flow-editor/blocks';

export default createBlocksModel({
  widgetName: 'Below content 2',
  props: {},
  methods: {},
  events: {},
});
